export enum DataSourceConnector {
  MongoDB = 'mongodb',
  MSSQL = 'mssql',
  PostgreSQL = 'postgresql',
  MySQL = 'mysql',
  File = 'file-storage',
  Salesforce = 'salesforce',
  REST = 'rest',
  Oracle = 'oracle',
  GoogleDrive = 'google-drive',
  MicrosoftOneDrive = 'microsoft-onedrive',
  AmazonS3 = 'amazon-s3',
  // Add other connectors as needed
}
export const DATA_SOURCES = [
  // --- File-Based Data Sources ---
  {
    name: 'File Storage',
    key: 'file-storage-add-multiple',
    iconName: 'fas fa-files',
    description: 'Upload multiple files by selecting any supported file types.',
    connector: DataSourceConnector.File,
  },
  {
    name: 'CSV',
    key: 'csv',
    iconName: 'fas fa-file-csv',
    description: 'Upload structured data from spreadsheets or tables. Ideal for reports, exports, and product catalogs.',
    connector: DataSourceConnector.File,
  },
  {
    name: 'PDF',
    key: 'pdf',
    iconName: 'fas fa-file-pdf',
    description: 'Extract text and data from documents, invoices, and scanned reports. Preserves original formatting.',
    connector: DataSourceConnector.File,
  },
  {
    name: 'Microsoft Word',
    key: 'docx',
    iconName: 'fas fa-file-word',
    description: 'Ingest content from contracts, manuals, and business documents created in Word.',
    connector: DataSourceConnector.File,
  },
  {
    name: 'Microsoft Excel',
    key: 'excel',
    iconName: 'fas fa-file-excel',
    description: 'Connect to spreadsheets with complex formulas, multiple sheets, and rich formatting.',
    connector: DataSourceConnector.File,
  },
  {
    name: 'Text Document',
    key: 'text',
    iconName: 'fas fa-file-alt',
    description: 'Upload plain text files (.txt). Perfect for logs, notes, or raw, unstructured information.',
    connector: DataSourceConnector.File,
  },
  {
    name: 'JSON',
    key: 'json',
    iconName: 'fas fa-file-code', // A more fitting icon for code
    description: 'Process semi-structured data from API responses or application configurations.',
    connector: DataSourceConnector.File,
  },
  // {
  //   name: 'XML',
  //   key: 'xml',
  //   iconName: 'fas fa-file-code',
  //   description: 'Ingest data from legacy systems or sources that use the XML markup language.',
  //   connector: DataSourceConnector.File,
  // },
  // {
  //   name: 'Parquet',
  //   key: 'parquet',
  //   iconName: 'fas fa-file-alt', // Generic file icon
  //   description: 'Upload large, complex datasets. Parquet is a columnar storage format optimized for big data analytics.',
  //   connector: DataSourceConnector.File,
  // },
  {
    name: 'Outlook Email PDB Database',
    key: 'outlook-email',
    iconName: 'fas fa-envelope',
    description: 'Extract data from Outlook email PDB files. Ideal for email analysis and insights.',
    connector: DataSourceConnector.File,
  },

  // --- Database Connectors ---
  {
    name: 'MongoDB',
    key: 'mongodb',
    iconName: 'fas fa-database',
    description: 'Connect to a NoSQL database. Great for flexible, JSON-like documents and large-scale applications.',
    connector: DataSourceConnector.MongoDB,
  },
  {
    name: 'PostgreSQL',
    key: 'postgresql',
    iconName: 'fas fa-database',
    description: 'Connect to a powerful, open-source object-relational SQL database known for reliability.',
    connector: DataSourceConnector.PostgreSQL,
  },
  {
    name: 'MySQL',
    key: 'mysql',
    iconName: 'fas fa-database',
    description: 'Connect to the popular open-source relational SQL database, widely used for web applications.',
    connector: DataSourceConnector.MySQL,
  },
  {
    name: 'Microsoft SQL Server',
    key: 'mssql',
    iconName: 'fas fa-database',
    description: 'Connect to Microsoft SQL Server. Ideal for enterprise-level applications and data warehousing.',
    connector: DataSourceConnector.MSSQL,
  },
  {
    name: 'Oracle Database',
    key: 'oracle',
    iconName: 'fas fa-database',
    description: 'Integrate with an Oracle database, a common choice for large, mission-critical enterprise systems.',
    connector: DataSourceConnector.Oracle,
  },
  // {
  //   name: 'SQLite',
  //   key: 'sqlite',
  //   iconName: 'fas fa-database',
  //   description: 'Upload a lightweight SQLite database file. Perfect for self-contained, serverless applications or exported data.',
  //   connector: DataSourceConnector.File, // Often handled as a file upload
  // },

  // --- API & Service Integrations ---
  {
    name: 'Open API',
    key: 'openapi',
    iconName: 'fas fa-plug',
    description: 'Connect to any service that provides an OpenAPI specification. Ideal for RESTful APIs with standardized documentation.',
    connector: DataSourceConnector.REST,
  },
  {
    name: 'REST API',
    key: 'rest',
    iconName: 'fas fa-plug',
    description: 'Connect to any external service or internal tool with a REST API to provide a live feed of data.',
    connector: DataSourceConnector.REST,
  },
  {
    name: 'Salesforce',
    key: 'salesforce',
    iconName: 'fab fa-salesforce', // Using the brand icon for better recognition
    description: 'Integrate directly with your Salesforce account to analyze CRM data like leads, opportunities, and accounts.',
    connector: DataSourceConnector.Salesforce,
  },
  {
    name: 'Google Drive',
    key: 'google-drive',
    iconName: 'fab fa-google-drive', // Using the brand icon for better recognition
    description: 'Integrate directly with your Google Drive account to access and analyze files stored in the cloud.',
    connector: DataSourceConnector.GoogleDrive,
  },
  {
    name: 'Microsoft OneDrive',
    key: 'microsoft-onedrive',
    iconName: 'fa-brands fa-microsoft', // Using the brand icon for better recognition
    description: 'Integrate directly with your Microsoft OneDrive account to access and analyze files stored in the cloud.',
    connector: DataSourceConnector.MicrosoftOneDrive,
  },
  {
    name: 'Amazon S3',
    key: 'amazon-s3',
    iconName: 'fa-brands fa-aws', // Using the brand icon for better recognition
    description: 'Integrate directly with your Amazon S3 account to access and analyze files stored in the cloud.',
    connector: DataSourceConnector.AmazonS3,
  },
  {
    name: 'Contact Us',
    key: 'contact-us-datasource',
    iconName: 'fas fa-headset',
    description: 'Need a custom data source integration? Contact our team and we\'ll work together to add the perfect solution for your needs.',
    color: {
      color: 'var(--primary-button-text-color)',
      backgroundColor: 'var(--info-color)'
    }
  }
];
